import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export const PainSection = () => {
  return <Section darker id="dolor" data-id="element-364">
      <div className="max-w-3xl mx-auto" data-id="element-365">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-366">
          ¿Te pasa esto?
        </h2>

        <div className="mt-12 space-y-4" data-id="element-367">
          <blockquote className="border-l-4 border-accent-blue pl-6 py-2 text-xl text-gray-200 italic bg-night-800/50 rounded-r-lg" data-id="element-368">
            "Estoy agotado físicamente pero mi cabeza no para."
          </blockquote>
          <blockquote className="border-l-4 border-accent-blue pl-6 py-2 text-xl text-gray-200 italic bg-night-800/50 rounded-r-lg" data-id="element-369">
            "Quiero dormir pero no puedo apagar los pensamientos."
          </blockquote>
          <blockquote className="border-l-4 border-accent-blue pl-6 py-2 text-xl text-gray-200 italic bg-night-800/50 rounded-r-lg" data-id="element-370">
            "Me duermo y me despierto a las 3 AM con la cabeza encendida."
          </blockquote>
        </div>

        <div className="mt-12 text-center" data-id="element-371">
          <p className="text-xl text-white font-medium mb-4" data-id="element-372">
            Si te identificaste con alguna de estas frases, seguí leyendo.
          </p>
          <p className="text-lg text-gray-400 mb-12" data-id="element-373">
            Porque lo que vas a encontrar acá cambió la noche de miles de
            personas.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-374">
            <Button href="#compra" fullWidth className="max-w-2xl mx-auto shadow-[0_0_30px_rgba(245,158,11,0.2)]" data-id="element-375">
              🔥 QUIERO DEJAR DE SUFRIR CADA NOCHE — MOSTRAME LA SOLUCIÓN
            </Button>
          </motion.div>
        </div>
      </div>
    </Section>;
};